import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "formTitle": "The 20th S-OIL CHAMPIONSHIP\nPRO-AM Participation Form",
          "privacyTitle": "The 20th S-OIL CHAMPIONSHIP RSVP - Agreement for the Collection of Personal Information",
          "privacyContent": `
            The Secretariat requests your consent to collect and use your personal information for the purpose of processing your application and operating the event.
            Your personal information will not be used for any purpose other than those stated above. The collected information will be securely destroyed after the event concludes.

            [Agreement for the Collection and Use of Personal Information]
            - Collected Information: Name, Date of Birth, Gender, Nationality, Address, Contact Information, Workplace
            - Purpose of Collection and Use: Management of Pro-Am participants and event operation
            - Retention and Usage Period: Stored for one month after the event, then destroyed

            You have the right to refuse consent; however, please note that refusal to consent may result in restrictions on your participation in the event. Do you agree to the collection and use of your personal information as described above?
            `
          ,
          'privacyContentThirdParty': `
            [Agreement for Provision of Personal Information to Third Parties]
            - Recipient: Brion Company (Event Operations Partner)
            - Purpose of the Recipient’s Use: Management of Pro-Am participants and event operation
            - Information Provided: Name, Date of Birth, Gender, Nationality, Address, Contact Information, Workplace
            - Retention and Usage Period by the Recipient: Stored for one month after the event, then destroyed

            You have the right to refuse consent; however, please note that refusal to consent may result in restrictions on your participation in the event. Do you agree to the collection and use of your personal information as described above?
          `,
          'yes': 'Yes',
          'no': 'No',
          'name': 'Name(Full Name)',
          'fullName': 'Full Name',
          'gender': 'Gender',
          'male': 'Male',
          'female': 'Female',
          'birth': 'Date of Birth',
          'nationality': 'Nationality',
          'rok': 'Republic of Korea',
          'company': 'Company',
          'position': 'Position',
          'address': 'Delivery Address',
          'officePhone': 'Delivery Contact Number',
          'mobilePhone': 'Mobile Phone Number',
          'flightDeparture': 'Airport of Departure (domestic flight)',
          'flightArrival': 'Airport of Arrival (domestic flight)',
          'flightSchedule': 'Flight Schedule (Gimpo ↔ Jeju)',
          'flightScheduleTitle': 'Please review and enter your flight schedule',
          'use': 'Use',
          'notUse': 'Do not use',
          'valetService': 'Gimpo Airport Valet Service',
          'valetVehicleNumber': 'Gimpo Airport Valet Service',
          'vehicleNumber': '(e.g. 123가4567)',
          'valetNotice': '※ If you wish to use the Gimpo Airport valet service on the day of the Pro-Am, select "Use" and enter your vehicle number.',
          'departureDefault': `Gimpo → Jeju
: Depart at 06:20AM Oct.28`,
          'arrivalDefault': `Jeju → Gimpo
: Depart at 8:45PM Oct.28`,
          'other': 'Others',
          'submit': 'Submit',
          'gloveSize': 'Glove Size',
          'leftHanded': 'Left-handed golfer',
          'specialMeal': `Special Meal Request
          (Vegan, Food Allergy, etc)`,
          'none': 'None',
          'specialMealDescription': 'Input request details',
          'submitHelp': `※ After entering all the information, please click the 'SUBMIT' below.`,
          'additional': `※ Inquiries : Secretariat (Tel : +82-2-6214-0104, Mobile : +82-10-9274-7270, Email : ms0729@brion.co.kr)`,
          'eventInfo': 'EVENT INFO',
          'close': 'Close',
          'error': 'Error',
          'formError': 'Please check the input value following fields:',
          'language': 'Language',
          'privacySectionTitle': 'Privacy Consent',
          'eventDetailsTitle': 'Event Details',
          'customerInfoTitle': 'Please review and enter your information',
          'eventDateLabel': 'Date',
          'eventDateValue': 'Wednesday, October 28, 2026',
          'eventLocationLabel': 'Venue',
          'eventLocationValue': 'Elysian Jeju (1738-116 Pyeonghwa-ro, Aewol-eup, Jeju-si)',
          'flightNotice': `※ The 06:20 flight departing from Gimpo and the 20:45 flight departing from Jeju are block-booked flights secured to ensure the smooth operation of the Pro-Am schedule.

If you wish to depart from a different domestic airport in Korea or at a different time, please select “Others” and provide the airport name and detailed itinerary.

If you plan to use only one leg of the round trip, please select “Others” for the unused leg and enter “Not Used.”`,
          'selectionError': 'Please select an option for all choice fields.',
          'submitSuccess': 'Your application has been successfully submitted.',
          'networkError': 'Network error. Please try again. If the problem persists, please contact the secretariat.',
          'invalidInvitation': 'The invitation link is invalid. Please contact the secretariat.',
          'agreementError': 'Please agree to the collection and use of personal information.',
          'notification': 'Notification',
          'deliveryHelp': '※ Please fill in your address where you can receive caddie bag flight cover prepared by S-OIL.',
        }
      },
      ko: {
        translation: {
          "formTitle": "The 20th S-OIL CHAMPIONSHIP\n프로암 참가 신청서",
          "privacyTitle": "The 20th S-OIL CHAMPIONSHIP – 개인정보 수집 동의",
          "privacyContent": `
            대회 사무국은 참가 신청서 작성 및 대회 운영을 위해 고객님의 개인정보를 수집하고자 합니다.

            수집된 개인정보는 프로암 참가 고객 관리 및 대회 운영 목적을 위해 사용됩니다. 동의하신 개인정보는 위에 명시된 수집 및 이용 목적 외로 사용되지 않습니다. 수집된 개인정보는 대회 종료 후 안전하게 파기됩니다.

            [개인정보 수집 이용 동의]
            - 개인정보 수집 항목: 이름, 생년월일, 성별, 국적, 주소, 연락처, 직장
            - 개인정보 수집 및 이용목적: 참가 고객 관리 및 대회 운영
            - 보유 및 이용기간 : 행사 종료 후 1개월간 보관 후 파기

            귀하는 동의를 거부할 권리가 있으며, 동의 거부 시 대회 참가 신청이 제한될 수 있음을 안내드립니다. 개인정보 수집 및 이용에 동의하십니까?
            `
          ,
          'privacyContentThirdParty': `
            [개인정보 제3자 제공 동의]
            - 제공받는자 : 브리온컴퍼니
            - 제공받는 자의 이용 목적 : 참가 고객 관리 및 대회 운영
            - 제공받는 항목 : 이름, 생년월일, 성별, 국적, 주소, 연락처, 직장
            - 제공받는 자의 보유 및 이용기간 : 행사 종료 후 1개월 간 보관 후 파기

            귀하는 동의를 거부할 권리가 있으며, 동의 거부 시 대회 참가 신청이 제한될 수 있음을 안내드립니다. 개인정보 제 3자 제공에 동의하십니까?
          `,
          'yes': '예',
          'no': '아니요',
          'name': '성함',
          'gender': '성별',
          'male': '남',
          'female': '여',
          'birth': '생년월일',
          'nationality': '국적',
          'rok': '대한민국',
          'company': '회사',
          'position': '직위',
          'address': '택배 수령 주소',
          'officePhone': '택배 수령 연락처',
          'mobilePhone': '본인 휴대폰 번호',
          'flightDeparture': '출발 공항',
          'flightArrival': '도착 공항',
          'flightSchedule': '항공 일정 (김포 ↔ 제주)',
          'flightScheduleTitle': '고객님의 항공 일정을 확인 및 입력해주세요',
          'use': '이용',
          'notUse': '미이용',
          'valetService': '김포 공항 발렛 서비스',
          'valetVehicleNumber': '김포 공항 발렛 서비스',
          'vehicleNumber': '(예: 123가4567)',
          'valetNotice': "※ 프로암 당일, 김포 공항 발렛 서비스를 희망하실 경우, '이용' 항목 체크 후 차량 번호를 반드시 기입해 주시기 바랍니다.",
          'departureDefault': `김포발 → 제주행
10/28(수) 06:20`,
          'arrivalDefault': `제주발 → 김포행
10/28(수) 20:45`,
          'other': '기타',
          'submit': '정보 전송',
          'gloveSize': '장갑 사이즈',
          'leftHanded': '좌타자인 경우 체크',
          'specialMeal': '채식/알레르기 등 식사 관련 요청',
          'none': '없음',
          'specialMealDescription': '요청 사항 입력',
          'submitHelp': `※ 모든 정보를 입력하신 후 아래 '정보 전송'을 클릭해 주시기 바랍니다.`,
          'additional': `※ 문의 : 대회사무국(Tel : 02-6214-0104, Mobile : 010-9274-7270, Email : ms0729@brion.co.kr)`,
          'eventInfo': '대회 안내',
          'close': '닫기',
          'error': '오류',
          'formError': '다음 항목의 정보를 확인해 주세요:',
          'language': '언어',
          'privacySectionTitle': '개인정보 동의',
          'eventDetailsTitle': '대회 정보',
          'customerInfoTitle': '고객님의 정보를 확인 및 입력해주세요',
          'eventDateLabel': '일시',
          'eventDateValue': '2026년 10월 28일 수요일',
          'eventLocationLabel': '장소',
          'eventLocationValue': '엘리시안 제주(제주시 애월읍 평화로 1738-116)',
          'flightNotice': `※ 아래 김포 출발 06:20, 제주 출발 20:45 항공편은 원활한 프로암 일정 진행을 위해 확보된 블록 항공편입니다.

해당 편 이용을 희망하시는 경우 해당 항공편을 체크해주시기 바랍니다.

해당 블럭 항공편 외 다른 지역 또는 시간대 출발을 희망하실 경우 '기타' 항목 체크 후 공항 명과 일정 등 상세 내용을 기입해 주시기 바랍니다.

또한, 왕복 일정 중 편도만 이용하실 경우, 이용하지 않는 일정에는 '기타' 항목 체크 후 '미이용'으로 기입해 주시기 바랍니다.`,
          'selectionError': '모든 선택 항목을 확인해 주세요.',
          'submitSuccess': '참가 신청이 완료되었습니다.',
          'networkError': '네트워크 오류입니다. 다시 시도해 주세요. 문제가 지속되면 사무국으로 연락해 주세요.',
          'invalidInvitation': '초대 링크가 올바르지 않습니다. 사무국으로 문의해 주세요.',
          'agreementError': '개인정보 수집 및 이용에 동의해 주세요.',
          'nameEng': '영문 성함(Full Name)',
          'notification': '알림',
          'deliveryHelp': '※ 캐디백 항공커버를 사전에 발송해 드릴 예정이오니 수령하실 주소를 반드시 기입하여 주시기 바랍니다.',
        }
      }
    },
    lng: "ko", // if you're using a language detector, do not define the lng option
    fallbackLng: "ko",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });
